<h1 class="center">Ajouter un utilisateur</h1>
<form [formGroup]="formGroup" id="add-porteur-form" (ngSubmit)="submitForm()">
  <mat-card class="mat-elevation-z center-content">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
      <mat-tab label="Identité">
        <mat-divider></mat-divider>
        <app-porteur-identity-form [group]="identity"></app-porteur-identity-form>
      </mat-tab>
      <mat-tab id="tab-vetement" label="Vêtements de travail" formArrayName="dotation">
        <mat-divider></mat-divider>
        <p class="info-contact">
          Si l'article et/ou la règle de change hebdo ne sont pas disponibles, merci de
          <a routerLink="/contact-us">nous contacter</a>.
        </p>
        <div class="list-article">
          <mat-grid-list [cols]="breakpoint" rowHeight="1:1.1" gutterSize="20px"
            (window:resize)="onResize($event.target.innerWidth)" class="mt-5">
            <mat-grid-tile *ngFor="let control of dotation.controls">
              <app-porteur-dotation-form (onClose)="closeControl(control)" [control]="control">
              </app-porteur-dotation-form>
            </mat-grid-tile>
            <mat-grid-tile class="click">
              <div class="add-tile" (click)="addArticle()">
                <mat-icon>add_circle_outline</mat-icon>
                <h3>Ajouter un vêtement</h3>
              </div>
            </mat-grid-tile>
          </mat-grid-list>
        </div>
      </mat-tab>
      <mat-tab [disabled]="!formGroup.valid">
        <ng-template mat-tab-label>
          <button mat-raised-button color="primary" type="submit" [disabled]="!formGroup.valid">Enregistrer</button>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</form>